import React, { Component } from "react";
import {
    Link,
    NavLink
  } from "react-router-dom";
  
class Nav extends Component {
  render() {
    return (
        <div>
        <nav className="navbar navbar-expand-md navbar-light bg-white">
          <div className="container">
            <Link to="/" className="navbar-brand">
              Stefhan Campos
            </Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbar">
              <ul className="navbar-nav ml-auto">    
                <NavLink to="/software"  className="nav-link px-3">Software</NavLink>
                <NavLink to={{pathname: "https://stefhancampos.darkroom.tech/"}} className="nav-link px-3" target="_blank">Photography</NavLink>
                {/* <NavLink to="/blog" className="nav-link px-3">Blog</NavLink> */}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js